import React, {createContext, useReducer} from 'react';
import AppReducer from './AppReducer';

const initialState = {
   transactions: []
}

export const GlobalContext = createContext(initialState);

export const GlobalProvider = ({children}) => {
   const [state, dispatch] = useReducer(AppReducer, initialState);

   const deleteTransaction = (id) => {
      dispatch({
         type: "DELETE_TRANSACTION",
         payload: id
      });
   }

   const addTransaction = (name,price) => {
      dispatch({
         type: "ADD_TRANSACTION",
         id: new Date().getTime(),
         name: name,
         amount: +price
      })
   }

   return (
      <GlobalContext.Provider value = {{transactions: state.transactions, deleteTransaction, addTransaction}}>
         {children}
      </GlobalContext.Provider>
   );
}
